import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

// reactstrap
import { Card, CardBody, CardTitle, CardSubtitle, Button, Row, Col, Form, FormGroup, Label, Input } from 'reactstrap'

// fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

// components
import Loading from '../../components/Loading/Loading';
import TituloLogin from './components/TituloLogin';

// api
import usuario_api from '../../api/usuario_api';

// helpers
import { showMessage } from '../../helpers/message';

export default function EsqueceuSenha() {
    const navigate = useNavigate();
    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        defaultValues: {
            email: '',
            cpfcnpj: ''
        }
    });

    // Controla exibição do loading
    const [loading, setLoading] = React.useState(false);

    const onSubmit = (data) => {
        setLoading(true);
        let json_submit = {
            CpfCnpj: data.cpfcnpj,
            Email: data.email
        }

        usuario_api.recuperarsenha(json_submit).then(result => {
            setLoading(false);
            if (result.status !== 200)
                showMessage("Aviso", result.message, "error");
            else
                showMessage("Aviso", "Operação executada com sucesso! Verifique seu e-mail.", 'success', navigate(`/auth/login`));
        })
            .catch(e => {
                setLoading(false);
                showMessage("Aviso", e.message, "error");
            })
    }
    function onChangeInput(e) {
        const { name, value } = e.target;
        setValue(name, value);
    }
    return (
        <div>
            {loading && (<Loading />)}
            <Card style={{ marginTop: "10vh" }}>
                <CardBody >
                    <Row className='mt-3 pl-3'>
                        <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-center'>
                            <TituloLogin></TituloLogin>
                        </Col>
                        <Col lg='6' md='12' className='text-left'>
                            <CardTitle tag={'h4'} className='fw-normal text-center'>Preencha os dados abaixo para recuperar sua senha</CardTitle>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <FormGroup className='text-left'>
                                    <Label className='font-weight-light label'>
                                        CPF/CNPJ
                                    </Label>
                                    <Input id="cpfcnpj" name="cpfcnpj" type="text" invalid={errors.cpfcnpj ? true : false} {...register("cpfcnpj", { required: "* Campo obrigatorio" })} onChange={onChangeInput} />
                                    {errors.cpfcnpj && <span className={"form-control-label text-danger"}>{errors.cpfcnpj.message}</span>}
                                </FormGroup>
                                <FormGroup className='text-left'>
                                    <Label className='font-weight-light label'>
                                        Email
                                    </Label>
                                    <Input id="email" name="email" type="email" invalid={errors.email ? true : false} {...register("email", { required: "* Campo obrigatorio" })} onChange={onChangeInput} />
                                    {errors.email && <span className={"form-control-label text-danger"}>{errors.email.message}</span>}
                                </FormGroup>
                                <div className="mt-3 d-flex justify-content-around align-items-center">
                                    <Button color='secondary' className='px-2 d-flex align-items-center justify-content-between mb-3' onClick={() => navigate(`/auth/login`)}>
                                        <FontAwesomeIcon icon={faArrowLeft} className="mx-2" />
                                        Voltar
                                    </Button>
                                    <Button type="submit" color='success' className='fw-bold px-4 mb-3' >
                                        Enviar Email
                                    </Button>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    )
}